/* Dentistique — dq-fit.js (03.09.2026, uwaga #5): wyrównuje wielkość produktów na kartach.
   Analizuje przezroczystość/biel packshotu i skaluje obraz tak, by sam produkt zajmował ~82% wysokości kafelka. */
(function () {
  try { if (/[?&]dq_demo=1/.test(location.search)) sessionStorage.setItem('dq_demo', '1'); if (sessionStorage.getItem('dq_demo') === '1') document.documentElement.classList.add('dq-demo'); } catch (e) {}
  var TARGET = 0.82, cache = {}, timer = null;
  function analyze(src, cb) {
    if (cache[src] !== undefined) { cb(cache[src]); return; }
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 120, H = Math.max(1, Math.round(im.naturalHeight * W / im.naturalWidth));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, minX = W, minY = H, maxX = -1, maxY = -1, opaque = true;
        /* 13.09: liczymy nie-białe piksele per kolumna/wiersz; pomijamy 1-px ramkę (artefakt skalowania CDN przy width=165/360
           — szara krawędź 243/243/243 w LEBON) i wymagamy >= 3% pikseli, żeby pojedynczy szum nie rozciągał ramki. */
        var cols = [], rows = [], k;
        for (k = 0; k < W; k++) cols[k] = 0; for (k = 0; k < H; k++) rows[k] = 0;
        for (var y = 0; y < H; y++) for (var i = 0; i < W; i++) {
          var o = (y * W + i) * 4, a = d[o + 3];
          if (a < 24) { opaque = false; continue; }
          if (d[o] > 238 && d[o + 1] > 238 && d[o + 2] > 238) continue;
          cols[i]++; rows[y]++;
        }
        var minC = Math.ceil(H * 0.03), minR = Math.ceil(W * 0.03);
        for (i = 1; i < W - 1; i++) if (cols[i] >= minC) { if (i < minX) minX = i; maxX = i; }
        for (y = 1; y < H - 1; y++) if (rows[y] >= minR) { if (y < minY) minY = y; maxY = y; }
        var res = (maxX < 0) ? null : { x: minX / W, y: minY / H, w: (maxX - minX + 1) / W, h: (maxY - minY + 1) / H, opaque: opaque };
        cache[src] = res; cb(res);
      } catch (e) { cache[src] = null; cb(null); }
    };
    im.onerror = function () { cache[src] = null; cb(null); };
    im.src = src;
  }
  function fit(img) {
    if (img.dataset.dqFit) return;
    var src = img.currentSrc || img.src; if (!src) return;
    img.dataset.dqFit = '1';
    analyze(src, function (bb) {
      if (bb && bb.opaque) img.classList.add('dq-opaque');
      if (!bb || bb.h < 0.05) return;
      var box = img.parentElement.getBoundingClientRect(), ib = img.getBoundingClientRect();
      if (!box.height || !ib.height) { img.dataset.dqFit = ''; return; }
      var ph = bb.h * ib.height, pw = bb.w * ib.width;
      var s = Math.min(TARGET * box.height / ph, 0.9 * box.width / pw);
      s = Math.max(0.55, Math.min(s, 2.4));
      var cx = (bb.x + bb.w / 2 - 0.5) * ib.width, cy = (bb.y + bb.h / 2 - 0.5) * ib.height;
      img.style.transformOrigin = 'center';
      img.style.transform = 'translate(' + (-cx * s).toFixed(1) + 'px,' + (-cy * s).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
    });
  }
  function run() {
    document.querySelectorAll('.card__media .media img').forEach(function (img) {
      if (img.complete && img.naturalWidth) fit(img);
      else img.addEventListener('load', function () { fit(img); }, { once: true });
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 120); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { document.querySelectorAll('[data-dq-fit]').forEach(function (i) { i.dataset.dqFit = ''; }); run(); }, 200); });
})();


/* Dentistique — widżet subskrypcji v2 (05.09.2026, uwaga #14 Jakuba): przełącznik „Jednorazowo / Subskrypcja”
   + kafelki rytmu dostaw z rabatem % i ceną, etykieta „najczęściej wybierane”, reasekuracja, data kolejnej dostawy.
   Zastępuje wersję z 04.09 (Amazon-style lista). Działa na DOM aplikacji Shopify Subscriptions (radio buttons zostają,
   my tylko dokładamy warstwę UI); idempotentne — app przerenderowuje widżet po zmianie wariantu. */
(function () {
  var MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
  var POPULAR = /co 4 tyg/i; // 06.09.2026: 3 rytmy 2/4/8 tyg., „najczęściej wybierane” = co 4 tyg.
  var timer = null;

  function parsePrice(t) {
    var m = (t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{1,2})?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : NaN;
  }
  function money(v) { return v.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' zł'; }
  function fmtDate(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function nextDate(title) {
    var t = (title || '').toLowerCase(), d = new Date();
    var n = (t.match(/co\s+(\d+)/) || [0, 1])[1] * 1 || 1;
    if (/tydz|tyg/.test(t)) d.setDate(d.getDate() + 7 * n);
    else if (/mies/.test(t)) d.setMonth(d.getMonth() + n);
    else if (/rok|lat/.test(t)) d.setFullYear(d.getFullYear() + n);
    else return null;
    return d;
  }
  function shortTitle(t) {
    return (t || '').replace(/^\s*dostawa\s+/i, '').replace(/,\s*\d+\s*%\s*zni[żz]ki\s*/i, '').trim();
  }
  function firstText(el) { return el && el.childNodes[0] ? el.childNodes[0].textContent : (el ? el.textContent : ''); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function oneTimeInput(widget) {
    return Array.prototype.find.call(widget.querySelectorAll('input[type="radio"]'), function (i) { return !i.closest('label.group_list_item'); });
  }
  function checkedPlan(widget) { return widget.querySelector('label.group_list_item input:checked'); }

  function enhance(widget) {
    var fieldset = widget.querySelector('.shopify_subscriptions_fieldset');
    if (!fieldset) return;
    var oneTime = Array.prototype.find.call(widget.querySelectorAll('.in_widget_price'), function (p) { return !p.closest('label.group_list_item'); });
    var base = oneTime ? parsePrice(firstText(oneTime)) : NaN;
    var best = 0, minPrice = NaN;
    var otInput = oneTimeInput(widget), otLabel = otInput ? otInput.closest('label') : null;
    if (otLabel && !otLabel.classList.contains('dq-onetime-row')) otLabel.classList.add('dq-onetime-row');

    // kafelki rytmu
    widget.querySelectorAll('label.group_list_item').forEach(function (item) {
      var title = item.querySelector('.title_and_price_wrapper > span:first-child');
      var price = item.querySelector('.in_widget_price');
      if (!title || !price) return;
      if (!title.dataset.dqFull) title.dataset.dqFull = firstText(title).trim();
      var short = shortTitle(title.dataset.dqFull);
      if (title.childNodes[0] && title.childNodes[0].nodeType === 3 && title.childNodes[0].textContent !== short) title.childNodes[0].textContent = short;
      var p = parsePrice(firstText(price));
      if (!isNaN(p) && (isNaN(minPrice) || p < minPrice)) minPrice = p;
      var pct = (!isNaN(base) && !isNaN(p) && base > p) ? Math.round((base - p) / base * 100) : 0;
      if (pct > best) best = pct;
      var tag = item.querySelector('.dq-sub-pct');
      if (pct > 0) {
        if (!tag) { tag = document.createElement('span'); tag.className = 'dq-sub-pct'; title.appendChild(tag); }
        setText(tag, '−' + pct + '%');
      } else if (tag) { tag.remove(); }
      var save = price.querySelector('.dq-sub-save');
      if (pct > 0) {
        if (!save) { save = document.createElement('span'); save.className = 'dq-sub-save'; price.appendChild(save); }
        setText(save, 'oszczędzasz ' + money(base - p));
      } else if (save) { save.remove(); }
      if (POPULAR.test(title.dataset.dqFull) && !item.querySelector('.dq-sub-badge')) {
        var b = document.createElement('span'); b.className = 'dq-sub-badge'; b.textContent = 'najczęściej wybierane';
        item.appendChild(b);
      }
    });

    // przełącznik Jednorazowo / Subskrypcja (raz)
    var sw = widget.querySelector('.dq-subs-switch');
    if (!sw) {
      sw = document.createElement('div'); sw.className = 'dq-subs-switch'; sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Sposób zakupu');
      sw.innerHTML = '<button type="button" class="dq-subs-switch__btn" data-mode="once"><span class="dq-subs-switch__t">Zakup jednorazowy</span><span class="dq-subs-switch__p"></span></button>' +
        '<button type="button" class="dq-subs-switch__btn" data-mode="sub"><span class="dq-subs-switch__t">Subskrypcja</span><span class="dq-subs-switch__p"></span><span class="dq-subs-switch__s"></span></button>';
      widget.insertBefore(sw, fieldset);
      var intro = document.createElement('p'); intro.className = 'dq-subs-intro';
      intro.textContent = 'Kolejne opakowanie przychodzi samo, a Ty oszczędzasz przy każdej dostawie — z darmową wysyłką. Wybierz rytm:';
      widget.insertBefore(intro, fieldset);
      sw.addEventListener('click', function (e) {
        var btn = e.target.closest('.dq-subs-switch__btn'); if (!btn) return;
        var target;
        if (btn.dataset.mode === 'once') target = oneTimeInput(widget);
        else {
          target = checkedPlan(widget) || Array.prototype.find.call(widget.querySelectorAll('label.group_list_item'), function (l) { var t = l.querySelector('.title_and_price_wrapper > span:first-child'); return t && POPULAR.test(t.dataset.dqFull || t.textContent); });
          if (target && target.tagName === 'LABEL') target = target.querySelector('input');
          if (!target) target = widget.querySelector('label.group_list_item input');
        }
        if (target && !target.checked) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
        sync(widget);
      });
    }
    var pOnce = sw.querySelector('[data-mode="once"] .dq-subs-switch__p');
    var pSub = sw.querySelector('[data-mode="sub"] .dq-subs-switch__p');
    var sSub = sw.querySelector('[data-mode="sub"] .dq-subs-switch__s');
    if (!isNaN(base)) setText(pOnce, money(base));
    if (!isNaN(minPrice)) setText(pSub, money(minPrice));
    setText(sSub, best > 0 ? '−' + best + '%' : ''); // 06.09: jeden rabat dla wszystkich rytmów → bez „do”

    // reasekuracja + data kolejnej dostawy (raz)
    if (!widget.querySelector('.dq-sub-note')) {
      var note = document.createElement('ul'); note.className = 'dq-sub-note';
      note.innerHTML = '<li>Dostawa każdej paczki subskrypcyjnej gratis — bez progu 200 zł.</li>' +
        '<li>Bez zobowiązań — anulujesz jednym kliknięciem w swoim koncie.</li>' +
        '<li>Przypomnimy e-mailem przed każdą kolejną dostawą.</li>' +
        '<li>Pominiesz dostawę lub zmienisz rytm w każdej chwili. <a href="/policies/subscription-policy">Zasady subskrypcji</a></li>';
      var next = document.createElement('p'); next.className = 'dq-sub-next'; next.hidden = true;
      widget.appendChild(next); widget.appendChild(note);
    }
    sync(widget);
  }

  function sync(widget) {
    var plan = checkedPlan(widget);
    widget.classList.toggle('dq-subs--sub', !!plan);
    widget.classList.toggle('dq-subs--once', !plan);
    widget.querySelectorAll('.dq-subs-switch__btn').forEach(function (b) {
      var on = (b.dataset.mode === 'sub') === !!plan;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var next = widget.querySelector('.dq-sub-next'); if (!next) return;
    if (!plan) { next.hidden = true; return; }
    var item = plan.closest('label.group_list_item');
    var title = item ? item.querySelector('.title_and_price_wrapper > span:first-child') : null;
    var d = title ? nextDate(title.dataset.dqFull || firstText(title)) : null;
    if (!d) { next.hidden = true; return; }
    var h = 'Pierwsza dostawa: <strong>wysyłamy dziś lub jutro</strong>. Kolejna: <strong>' + fmtDate(d) + '</strong> — datę i rytm zmienisz w koncie.';
    if (next.innerHTML !== h) next.innerHTML = h;
    next.hidden = false;
  }

  function run() { document.querySelectorAll('.shopify_subscriptions_app_block').forEach(enhance); }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 80); }

  document.addEventListener('change', function (e) {
    var w = e.target && e.target.closest && e.target.closest('.shopify_subscriptions_app_block');
    if (w) sync(w);
  });
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('.shopify_subscriptions_app_block')) {
        if (t.closest('.dq-subs-switch, .dq-sub-note, .dq-sub-next, .dq-subs-intro') || (t.classList && (t.classList.contains('dq-sub-save') || t.classList.contains('dq-sub-pct')))) continue;
        schedule(); return;
      }
      if (t === document.body || (t.querySelector && t.querySelector('.shopify_subscriptions_app_block'))) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* dq 05.09.2026 — cena jednostkowa (zł/100 ml) i kwota VAT liczone dynamicznie z ceny wybranej opcji
   (zakup jednorazowy / plan subskrypcyjny). Aplikacja Subscriptions podmienia tylko cenę główną,
   więc przeliczamy resztę sami z danych produktu (/products/<handle>.js). Uwaga Jakuba z 05.09. */
(function () {
  var cache = null, timer = null;
  function money2(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function productJson() {
    if (cache) return cache;
    var path = location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) return Promise.reject();
    cache = fetch(path + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return cache;
  }
  function update() {
    var form = document.querySelector('.product__info-container form[action*="/cart/add"], .product__info-container product-form form');
    var idEl = form && form.querySelector('input[name="id"]');
    if (!idEl) return;
    var planEl = document.querySelector('.product__info-container input[name="selling_plan"]');
    var planId = planEl && planEl.value ? String(planEl.value) : '';
    productJson().then(function (p) {
      var v = null, i;
      for (i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(idEl.value)) v = p.variants[i];
      if (!v) return;
      var price = v.price, unit = v.unit_price, um = v.unit_price_measurement;
      if (planId && v.selling_plan_allocations) {
        for (i = 0; i < v.selling_plan_allocations.length; i++) {
          var a = v.selling_plan_allocations[i];
          if (String(a.selling_plan_id) === planId) { price = a.per_delivery_price || a.price; unit = a.unit_price; break; }
        }
      }
      var unitEl = document.querySelector('.product__info-container .unit-price .price-item');
      if (unitEl && unit && um && um.reference_unit) {
        var ref = (um.reference_value && Number(um.reference_value) !== 1 ? um.reference_value : '') + um.reference_unit;
        var txt = money2(unit) + '/' + ref;
        if (unitEl.textContent.trim() !== txt) unitEl.textContent = txt;
      }
      var taxEl = document.querySelector('.product__info-container .product__tax');
      if (taxEl && price) {
        var vat = Math.round(price * 23 / 123);
        var t = 'w tym 23% VAT (' + money2(vat) + ')';
        if (taxEl.textContent.trim() !== t) taxEl.textContent = t;
      }
    }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(update, 150); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.product__info-container')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('.price') && !t.closest('.unit-price')) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
})();


/* dq 06.09.2026 — #138 licznik ulubionych: "(3)" -> "3" (Wishlist Hero wstawia nawiasy) */
(function(){function fix(){document.querySelectorAll('.wishlist-hero-items-count').forEach(function(e){var t=e.textContent.replace(/[()\s]/g,'');if(e.textContent!==t)e.textContent=t;});}fix();document.addEventListener('DOMContentLoaded',fix);new MutationObserver(fix).observe(document.documentElement,{childList:true,subtree:true,characterData:true});})();


/* dq 06.09.2026 — #146 kolejność rytmów subskrypcji rosnąco (co 2 / 4 / 8 tyg.) niezależnie od kolejności w aplikacji */
(function(){
  function weeks(t){t=(t||'').toLowerCase();var m=t.match(/co\s+(\d+)?/);var n=m&&m[1]?+m[1]:1;if(/mies/.test(t))return n*4.35;if(/tydz|tyg/.test(t))return n;if(/dzie|dni/.test(t))return n/7;return 999;}
  function sortPlans(){
    document.querySelectorAll('ul.group_list').forEach(function(ul){
      var lis=[].slice.call(ul.children).filter(function(li){return /co\s+\d*\s*(tyg|tydz|mies)/i.test(li.textContent)});
      if(lis.length<2)return;
      var sorted=lis.slice().sort(function(a,b){return weeks(a.textContent)-weeks(b.textContent)});
      if(sorted.every(function(el,i){return el===lis[i]}))return;
      var anchor=lis[lis.length-1].nextSibling;sorted.forEach(function(el){ul.insertBefore(el,anchor)});
    });
  }
  sortPlans();document.addEventListener('DOMContentLoaded',sortPlans);
  new MutationObserver(function(){sortPlans()}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* dq 06.09.2026 — #147 widżet subskrypcji: rabat i oszczędność tylko raz (nad rytmami), rytmy bez powtórzonych cen; w trybie jednorazowym łagodna informacja o różnicy */
(function(){
  function parse(t){var m=(t||'').replace(/\s/g,'').match(/(\d+(?:[.,]\d{1,2})?)/);return m?parseFloat(m[1].replace(',','.')):NaN;}
  function money(v){return v.toFixed(2).replace('.',',').replace(/,00$/,'')+' zł';}
  function apply(){
    document.querySelectorAll('.shopify_subscriptions_app_block').forEach(function(w){
      var sw=w.querySelector('.dq-subs-switch'); if(!sw) return;
      var once=parse((sw.querySelector('[data-mode="once"] .dq-subs-switch__p')||{}).textContent);
      var sub=parse((sw.querySelector('[data-mode="sub"] .dq-subs-switch__p')||{}).textContent);
      if(isNaN(once)||isNaN(sub)||sub>=once) return;
      var diff=once-sub;
      var intro=w.querySelector('.dq-subs-intro');
      if(intro){
        var h='Każda paczka <strong>'+money(sub)+'</strong> zamiast '+money(once)+' — oszczędzasz <strong>'+money(diff)+'</strong>, dostawa zawsze gratis. Wybierz rytm:';
        if(intro.innerHTML!==h) intro.innerHTML=h;
      }
      var note=w.querySelector('.dq-once-note');
      if(!note){note=document.createElement('p');note.className='dq-once-note';sw.insertAdjacentElement('afterend',note);}
      var n='Bez subskrypcji ta sama paczka kosztuje o <strong>'+money(diff)+' więcej</strong>, a dostawa poniżej 200 zł jest płatna.';
      if(note.innerHTML!==n) note.innerHTML=n;
    });
  }
  apply(); document.addEventListener('DOMContentLoaded',apply);
  var t=null; new MutationObserver(function(){clearTimeout(t);t=setTimeout(apply,60);}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
})();


/* Dentistique - 09.09.2026, uwaga #190: nieskonczone przewijanie katalogu zamiast paginacji. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  // #208: ta sama mechanika w katalogu (#product-grid) i w poradniku (.blog-articles)
  function gridIn(root) { return (root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid')) || root.querySelector('.blog-articles'); }
  var busy = false, io = null, sent = null, lastGrid = null;
  function curPage() {
    var w = document.querySelector('.pagination-wrapper');
    if (!w) return 1;
    var el = w.querySelector('.pagination__item--current');
    return parseInt((el && el.textContent || '1').replace(/\D/g, ''), 10) || 1;
  }
  function nextUrl() {
    var w = document.querySelector('.pagination-wrapper');
    if (!w) return null;
    var cur = curPage(), found = null;
    Array.prototype.slice.call(w.querySelectorAll('a[href]')).forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1], 10) === cur + 1) found = a.href;
    });
    return found;
  }
  function clean() {
    if (io) { io.disconnect(); io = null; }
    if (sent && sent.parentNode) sent.parentNode.removeChild(sent);
    sent = null;
  }
  function init() {
    var grid = gridIn(document);
    var wrap = document.querySelector('.pagination-wrapper');
    clean();
    if (!grid || !wrap) return;
    if (curPage() === 1) wrap.classList.add('dq-pagination--auto');
    if (!nextUrl()) return;
    sent = document.createElement('div');
    sent.className = 'dq-infinite';
    sent.innerHTML = '<span class="dq-infinite__dot"></span><span class="dq-infinite__dot"></span><span class="dq-infinite__dot"></span><span class="visually-hidden">Wczytuje kolejne produkty</span>';
    wrap.parentNode.insertBefore(sent, wrap);
    io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '700px 0px' });
    io.observe(sent);
  }
  function load() {
    if (busy) return;
    var url = nextUrl();
    if (!url) { clean(); return; }
    busy = true;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ng = gridIn(doc), g = gridIn(document);
      if (ng && g) { Array.prototype.slice.call(ng.children).forEach(function (li) { g.appendChild(document.importNode(li, true)); }); }
      var np = doc.querySelector('.pagination-wrapper'), op = document.querySelector('.pagination-wrapper');
      if (op) op.innerHTML = np ? np.innerHTML : '';
      busy = false;
      if (!nextUrl()) clean(); else if (sent && sent.parentNode && op) op.parentNode.insertBefore(sent, op);
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }).catch(function () { busy = false; });
  }
  function watch() {
    var g = gridIn(document);
    if (g && g !== lastGrid) { lastGrid = g; init(); }
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
  document.addEventListener('shopify:section:load', watch);
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Dentistique - 09.09.2026, uwaga #191: opcja "Zapakuj na prezent" (+15 zl) przy zakupie jednorazowym. */
(function () {
  var GIFT_VARIANT = 58900648132992, GIFT_HANDLE = 'pakowanie-na-prezent';
  var GIFT_PROP = 'Dla produktu';
  function giftLabel() {
    var h1 = document.querySelector('.dq-title-row h1, .product__title h1');
    var sub = document.querySelector('.dq-subtitle');
    var name = h1 ? h1.textContent.trim() : document.title;
    if (sub) {
      var parts = sub.textContent.trim().split(',');
      var last = parts[parts.length - 1].trim();
      if (last && parts.length > 1) name += ', ' + last;
    }
    return name;
  }
  function subActive(form) {
    var sp = form.querySelector('[name="selling_plan"]');
    return !!(sp && sp.value && sp.value !== '');
  }
  function build(form) {
    var l = document.createElement('label');
    l.className = 'dq-gift';
    l.innerHTML = '<input type="checkbox" class="dq-gift__cb"><span class="dq-gift__body"><span class="dq-gift__line">Zapakuj na prezent <b>+15 z\u0142</b></span><span class="dq-gift__hint">Zawijamy r\u0119cznie, w papier w kolorach Dentistique. Dotyczy tego produktu.</span></span>';
    return l;
  }
  function init() {
    if (location.pathname.indexOf(GIFT_HANDLE) > -1) return;
    var forms = document.querySelectorAll('product-form form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.dqGift) return;
      // tylko karta produktu - nie w kafelkach katalogu ani w szybkim dodawaniu
      if (!form.closest('.product__info-container') || form.closest('.card-wrapper') || form.closest('.quick-add')) return;
      form.dataset.dqGift = '1';
      var host = form.querySelector('.product-form__buttons') || form;
      var box = build(form);
      host.parentNode.insertBefore(box, host);
      var cb = box.querySelector('.dq-gift__cb');
      function sync() {
        var add = form.querySelector('[name="add"]');
        box.hidden = subActive(form) || !!(add && add.disabled);
        if (box.hidden) cb.checked = false;
      }
      sync();
      form.addEventListener('change', sync);
      document.addEventListener('change', sync);
      form.addEventListener('submit', function (e) {
        if (form.dataset.dqGiftGo === '1') { form.dataset.dqGiftGo = ''; return; }
        if (!cb.checked || box.hidden) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var vid = (form.querySelector('[name="id"]') || {}).value;
        var label = giftLabel();
        function go() { form.dataset.dqGiftGo = '1'; if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var already = (cart.items || []).some(function (i) {
              return i.variant_id === GIFT_VARIANT && i.properties && String(i.properties._dq_gift_for) === String(vid);
            });
            if (already) return null;
            var props = { '_dq_gift_for': vid };
            props[GIFT_PROP] = label;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1, properties: props }] })
            });
          })
          .catch(function () {})
          .then(go);
      }, true);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Dentistique - 09.09.2026: sprzatanie osieroconych pozycji "Pakowanie na prezent" (dq-gift-cleanup). */
(function () {
  var GIFT_VARIANT = 58900648132992;
  if (location.pathname.indexOf('/cart') !== 0) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var items = cart.items || [];
      var present = {};
      items.forEach(function (i) { if (i.variant_id !== GIFT_VARIANT) present[String(i.variant_id)] = true; });
      var orphans = items.filter(function (i) {
        return i.variant_id === GIFT_VARIANT && i.properties && i.properties._dq_gift_for && !present[String(i.properties._dq_gift_for)];
      });
      if (!orphans.length) return;
      var chain = Promise.resolve();
      orphans.forEach(function (o) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: o.key, quantity: 0 }) });
        });
      });
      return chain.then(function () { location.reload(); });
    })
    .catch(function () {});
})();


/* Dentistique - 10.09.2026 #207: przypis 1) z sekcji opinii wedruje na sam dol strony, tuz nad stopke. */
(function () {
  function move() {
    var note = document.querySelector('.dq-reviews__note');
    if (!note || note.closest('.dq-page-notes')) return;
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.footer') || document.querySelector('footer');
    if (!footer || !footer.parentNode) return;
    var wrap = document.createElement('div');
    wrap.className = 'dq-page-notes page-width';
    wrap.appendChild(note);
    footer.parentNode.insertBefore(wrap, footer);
  }
  if (document.readyState !== 'loading') move(); else document.addEventListener('DOMContentLoaded', move);
  document.addEventListener('shopify:section:load', move);
})();


/* ===== #GALERIA (15.09) — strzałki < > na galerii karty produktu ===== */
(function () {
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M15 4 7 12l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function mediaId(li) {
    return li.getAttribute('data-media-id') || li.id.replace(/^Slide-/, '');
  }

  function go(gallery, dir) {
    var list = [].slice.call(gallery.querySelectorAll('.product__media-item'));
    if (list.length < 2) return;
    var cur = 0;
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-active')) { cur = i; break; }
    }
    var target = list[(cur + dir + list.length) % list.length];
    var id = mediaId(target);
    var thumb = gallery.querySelector('.thumbnail-list__item[data-target="' + id + '"] .thumbnail');
    if (thumb) thumb.click();
    else if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
    window.setTimeout(function () {
      var track = target.parentElement;
      if (!track || track.scrollWidth <= track.clientWidth + 4) return;
      var delta = target.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (Math.abs(delta) > 8) {
        if (track.scrollBy) track.scrollBy({ left: delta, behavior: 'smooth' });
        else track.scrollLeft += delta;
      }
    }, 80);
  }

  function init(gallery) {
    if (gallery.getAttribute('data-dq-nav')) return;
    if (gallery.querySelectorAll('.product__media-item').length < 2) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]') || gallery.querySelector('.product__media-list');
    if (!viewer) return;
    gallery.setAttribute('data-dq-nav', '1');
    viewer.classList.add('dq-gallery');
    [['prev', -1, ICON_PREV, 'Poprzednie zdjęcie'], ['next', 1, ICON_NEXT, 'Następne zdjęcie']].forEach(function (cfg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dq-gal-nav dq-gal-nav--' + cfg[0];
      b.innerHTML = cfg[2];
      b.setAttribute('aria-label', cfg[3]);
      b.addEventListener('click', function (e) { e.preventDefault(); go(gallery, cfg[1]); });
      viewer.appendChild(b);
    });
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    [].slice.call(root.querySelectorAll('media-gallery')).forEach(init);
  }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        [].slice.call(m.addedNodes).forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'MEDIA-GALLERY') init(n); else scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
